module.exports = __webpack_public_path__ + "static/default-a3f1704664035bd1538cde3c0c1e7886.png";